import { useMemo } from 'react';

import type { OAISchema } from '~/types/openapi';

type Props = {
  loading?: boolean;
  paymentResponse: OAISchema['MarketInShoppingCartDeliveryBundlePaymentResponse'];
};

export const CartVendorDeliveryInfo = ({
  loading,
  paymentResponse: {
    deliveryFee,
    conditionalFreeAmount,
    additionalDeliveryFee,
    deliveryFeeType,
  },
}: Props) => {
  const FeeComponent = useMemo(() => {
    switch (deliveryFeeType) {
      case 'FREE':
        return (
          <div className="flex justify-between">
            <span className="mr-[14px] text-hint typo-caption100-regular">
              구매 금액 상관없이 배송비 무료
            </span>
            <span className="text-right text-description typo-caption100-regular">
              배송비 0원
            </span>
          </div>
        );

      case 'FIX':
        return (
          <div className="flex justify-between">
            <span className="mr-[14px] text-hint typo-caption100-regular">
              구매 금액 상관없이 배송비 적용
            </span>
            <span className="text-right text-description typo-caption100-regular">
              배송비 {deliveryFee.toLocaleString()}원
            </span>
          </div>
        );

      default:
        return (
          <div className="flex justify-between">
            <span className="mr-[14px] text-hint typo-caption100-regular">
              {conditionalFreeAmount && conditionalFreeAmount > 0
                ? `${conditionalFreeAmount.toLocaleString()}원 이상 구매시 무료`
                : ''}
            </span>
            <span className="text-right text-description typo-caption100-regular">
              배송비 {deliveryFee.toLocaleString()}원
            </span>
          </div>
        );
    }
  }, [conditionalFreeAmount, deliveryFee, deliveryFeeType]);

  return (
    <div className="relative w-full overflow-x-hidden border-t border-solid border-t-gray-200 px-20 py-12">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-warmGray-000 opacity-60" />
      )}
      {FeeComponent}
      {additionalDeliveryFee ? (
        <div className="flex justify-between">
          <span className="mr-[14px] text-hint typo-caption100-regular">
            추가배송비 (제주, 도서산간)
          </span>
          <span className="text-right text-description typo-caption100-regular">
            추가배송비 {additionalDeliveryFee.toLocaleString()}원
          </span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
